import React from 'react';
import { costElements } from '../../data/costAccountingData';

const CostElementsView = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">成本要素</h2>
        <p className="text-gray-600">Cost Elements</p>
      </div>

      {/* Cost Elements header image */}
      <div className="relative h-48 mb-6 overflow-hidden rounded-lg shadow-md">
        <img 
          src="https://images.unsplash.com/photo-1565843248736-8c41e6db117b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
          alt="Cost Elements" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
          <h1 className="text-white text-3xl font-bold">成本要素管理</h1>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow-md">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">代碼</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">名稱</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">類型</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">單位</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">單位成本</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">狀態</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {costElements.map((element) => (
                <tr key={element.cost_element_id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{element.cost_element_code}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900">{element.cost_element_name}</div>
                    <div className="text-sm text-gray-500">{element.cost_element_name_en}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      element.cost_element_type === 'DIRECT_MATERIAL' ? 'bg-blue-100 text-blue-800' : 
                      element.cost_element_type === 'DIRECT_LABOR' ? 'bg-yellow-100 text-yellow-800' : 
                      element.cost_element_type === 'MANUFACTURING_OVERHEAD' ? 'bg-purple-100 text-purple-800' : 
                      'bg-gray-100 text-gray-800'}`}>
                      {element.cost_element_type}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{element.unit_of_measure}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">${element.unit_cost.toFixed(2)}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${element.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                      {element.is_active ? '活躍' : '非活躍'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CostElementsView;
